import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { LoteCabotajeService } from 'src/app/_services/loteCabotaje/lote-cabotaje.service';
import { ScaleTicketService } from 'src/app/_services/scale-ticket/scale-ticket.service';
import { TonsPerYardService } from 'src/app/_services/tons-per-yard/tons-per-yard.service';
import { BlDetails, TableConfig } from 'src/app/interfaces/bl.interfaces';
import { CabotageEntry } from 'src/app/interfaces/cabotageBatches.interfaces';
import { ExportTransportCreate, LocationInterface, SalidaCatalogo, TranportLine, Transport } from 'src/app/interfaces/lotes.interfaces';
import { GenericTicket, Module, OperationType, OriginTicket } from 'src/app/interfaces/scale-ticket.interfaces';
import { AmountsByInputLocationsComponent } from 'src/app/shared/components/amounts-by-input-locations/amounts-by-input-locations.component';

enum ScannerType {
  Scanner = 'scanner',
  Camera = 'camera',
  Close = 'close',
}
/**
 * Componente que gestiona el formulario de entrada por transporte de un lote de cabotaje,
 * incluyendo la captura de tickets de báscula, líneas de transporte, escaneo de códigos QR
 * y el registro o actualización de las entradas con sus pesos y piezas.
 */
@Component({
  selector: 'app-cabotage-entry-transport',
  templateUrl: './cabotage-entry-transport.component.html',
  styleUrls: ['./cabotage-entry-transport.component.css']
})
export class CabotageEntryTransportComponent implements OnInit {
  @Input() containerStyles = {
    'grid-template-columns': 'repeat(4, 1fr)'
  };
  @Input() movimiento: string = 'crear';
  @Input() entryDetalle: CabotageEntry[] = [];
  @Output() onRegresar = new EventEmitter<boolean>();
  @Output() onTipoEntrada = new EventEmitter<string>();
  entryForm: FormGroup;
  @Input() tipoTransporte: SalidaCatalogo[] = [];
  @Input() tipoUnidad: SalidaCatalogo[] = [];
  @Input() locations: LocationInterface[] = [];
  @Input() listTransportLine: TranportLine[] = [];
  listTransportLineFilter: TranportLine[] = [];
  @Input() entriesType: TranportLine[] = [];
  @Input() archivos = {
    ticketBascula: '',
  };
  @Input() originsTicket: OriginTicket[] = [];
  @Input() blDetails: BlDetails = {
    operation_number:     0,
    boats_name:           '',
    operation_type_number:0,
    bl_tonnage:           0,
    customer_name:        null,
    date_time_capture:    '',
    dock_name:            '',
    port_origin_name:     '',
    start_operations:     '',
    end_operations:       '',
    boat_nationality:     '',
    destination_port:     '',
    operation_id:         0,
    docking_date:         '',
    undocking_date:       '',
    bl_master:            '',
    notice_of_readiness:  '',
  };
  loaderRailwayGroup: boolean = false;
  table_config: TableConfig = {
    tableHeads: [
      ['Peso origen', 'origin_weight'],
      ['Peso bruto', 'gross_weight'],
      ['Peso tara', 'tare_weight'],
      ['Peso neto', 'net_weight'],
      ['Piezas', 'quantity_pieces'],
      ['Placas', 'plate'],
      ['Folio ticket', 'no_ticket']
    ],
    tableHeadsContainer: ['Detalle', 'Editar', 'Eliminar'],
    styles: {
      table_heads: {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) minmax(200px, auto)',
        'min-width': '830px',
      },
      table_row: {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) minmax(200px, auto)',
        'min-width': '830px',
      },
      container_icons: {
        'grid-template-columns': 'repeat(3, 1fr)',
      },
      table_row_totals: {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) minmax(200px, auto)',
        'min-width': '830px',
        'background-color': '#455660',
        'color': '#fff',
      },
    },
    arrayFields: [
      'origin_weight',
      'gross_weight',
      'tare_weight',
      'net_weight',
      'quantity_pieces',
      'plate',
      'no_ticket'
    ],
    iconos: [["/eliminar-abandono", "id", 'bi bi-eye'], ["/actualizar-abandono", "id", 'bi bi-pencil-square'], ["/eliminar-entry-export", "id", 'bi bi-trash3']],
    mensaje: "Sin registros.",
    filter: true,
    totals: {
      show: true,
      content: ['', '', 'Totales:', 'totalNetWeight', 'piezas', '', ''],
      total: 0,
      totalNetWeight: 0,
      piezas: 0,
    }
  };
  maxSize: boolean = false;
  mensajeError: string = 'Ingrese el archivo';
  overlay: boolean = false;
  mensajeOverlay: string = '';
  iconoOverlay: string = '';
  buttons: boolean = false;
  loading: boolean = false;
  entry: CabotageEntry = {
    cabotage_batch_id:      0,
    precinct_key:         0,
    tractor_plates:       '',
    transport_type_id:    0,
    trailer_id:           0,
    origin_weight:        0,
    gross_weight:         0,
    tare_weight:          0,
    net_weight:           0,
    van_plate:            '',
    folio_ticket_number:  '',
    origin_weight2:       0,
    gross_weight2:        0,
    tare_weight2:         0,
    net_weight2:          0,
    van_plate2:           '',
    folio_ticket_number2: '',
    total_weight:         0,
    cabotage_entrance_ticket:      '',
    checker_name:         '',
    operator_name:        '',
    transport_line:       '',
    admission_date:       '',
    number_pieces :       0,
    number_pieces2:       0,
    total_pieces  :       0,
    location_id:          0,
  };
  batchValue: number = 0;
  id: number = 0;
  entryTonnage: number = 0;
  entryPieces: number = 0;

  // Transport Line
  transportLineOverlay: boolean = false;
  loaderTransportLine: boolean = false;
  transportLine: FormControl = new FormControl();
  formTransportLine: FormControl = new FormControl();

  // Transport
  overlayTransport: boolean = false;
  confirmCreate: boolean = false;
  loader: boolean = false;
  transportForm: FormGroup;
  net_weight: number = 0;
  currentTransportId: number = 0;
  transportDelete: boolean = false;
  updateTranpostForm: boolean = false;
  idCount: number = 1;
  @Input() transportList: any[] = [];
  updateTransport: boolean = false;
  addTransport: boolean = false;
  currentIdTransport: number = 0;
  loaderTicket: boolean = false;
  isValidModule: boolean = false;
  messageTicket: string = '';
  ticketChangeCount: number = 0;

  tipoEntrada: FormControl = new FormControl('1');

  @ViewChild(AmountsByInputLocationsComponent) amountsComponent!: AmountsByInputLocationsComponent;

  // Scanner
  overlayScanner: boolean = false;
  scannerEnabled: boolean = false;
  gunScannerEnabled: boolean = true;
  isValidQR: boolean = true;
  autofocusEnabled: boolean = true;
  cameraSelected: FormControl = new FormControl();
  scannerTextArea: FormControl = new FormControl();
  selectedDevice!: MediaDeviceInfo;
  camerasList: MediaDeviceInfo[] = [];
  qrResultString: string | null = '';

  constructor(
    private authService: AuthService,
    private loteCabotajeService: LoteCabotajeService,
    private amountsPerYardSvc: TonsPerYardService,
    private scaleTicketSvc: ScaleTicketService,
    private localStorageSvc: LocalStorageService,
    private fb: FormBuilder,
    private router: Router,
  ) {
    const fullName = this.localStorageSvc.getFullName();
    const isCheckerNameDisabled = fullName ? true : false;
    this.entryForm = this.fb.group({
      entry_type_id: [],
      transport_type_id: ['', [Validators.required]],
      trailer_id: [''],
      origin_weight: [],
      gross_weight: [],
      tare_weight: [],
      net_weight: [],
      origin_weight2: [],
      gross_weight2: [],
      tare_weight2: [],
      net_weight2: [],
      van_plate: [],
      van_plate2: [],
      folio_ticket_number: [],
      folio_ticket_number2: [],
      cabotage_entrance_ticket: [],
      transport_line: ['', [Validators.required, Validators.maxLength(100)]],
      operator_name: [],
      admission_date: [this.getDate(), [Validators.required]],
      checker_name: [{value: fullName, disabled: isCheckerNameDisabled}, [Validators.required]],
      tractor_plates: [],
      precinct_key: [201, [Validators.required]],
      number_pieces : [],
      number_pieces2: [],
      original_scale_id: ['', [Validators.required]],
      railway_group: [],

      // Entry ship
      ship_number: [, [Validators.required]],
      ship_name: [, [Validators.required]],
      total_weight: [, [Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]],
      total_pieces  : [0, [Validators.required, Validators.pattern(/^\d{1,11}$/)]],
      bl_number: [, [Validators.required]],
      customs_agent: [, [Validators.required]],
      load_conditions: [],
      observations: [],
    });
    this.transportForm = fb.group({
      origin_weight: [, [Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]],
      gross_weight: [, [Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]],
      tare_weight: [, [Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]],
      quantity_pieces: [0, [Validators.required, Validators.pattern(/^[0-9]+$/)]],
      plate: [, [Validators.required]],
      no_ticket: [],
      file_ticket: [],
      no_slab: [],
      no_cast: [],
    });
  }

  ngOnInit(): void {
    const parts = this.router.url.split("/");
    this.batchValue = Number(parts[parts.length - 1]);
    this.tipoEntrada.valueChanges.subscribe( tipoEntrada => {
      this.onTipoEntrada.emit(tipoEntrada);
    });
    if (this.movimiento === 'detalle') {
      this.table_config.tableHeadsContainer = ['Boleta', 'Detalle'];
      this.table_config.styles.container_icons['grid-template-columns'] = "repeat(2, 1fr)";
      this.table_config.styles.table_heads['grid-template-columns'] = "repeat(7, minmax(90px, 1fr)) minmax(120px, auto)";
      this.table_config.styles.table_heads['min-width'] = "750px";
      this.table_config.styles.table_row['grid-template-columns'] = "repeat(7, minmax(90px, 1fr)) minmax(120px, auto)";
      this.table_config.styles.table_row['min-width'] = "750px";
      this.table_config.styles.table_row_totals!['grid-template-columns'] = "repeat(7, minmax(90px, 1fr)) minmax(120px, auto)";
      this.table_config.styles.table_row_totals!['min-width'] = "750px";
      this.table_config.iconos = [["/detalle-export-entry", "id_cabotage_weight_list", "bi bi-download"], ["/eliminar-abandono", "id_cabotage_weight_list", 'bi bi-eye']];
    } else if (this.movimiento === 'actualizar') {
      this.table_config.tableHeadsContainer = ['Detalle', 'Editar', 'Eliminar'];
      this.table_config.styles.container_icons['grid-template-columns'] = "repeat(3, 1fr)";
      this.table_config.styles.table_heads['grid-template-columns'] = "repeat(7, minmax(90px, 1fr)) minmax(200px, auto)";
      this.table_config.styles.table_row['grid-template-columns'] = "repeat(7, minmax(90px, 1fr)) minmax(200px, auto)";
      this.table_config.styles.table_row_totals!['grid-template-columns'] = "repeat(7, minmax(90px, 1fr)) minmax(200px, auto)";
      this.table_config.iconos = [["/eliminar-abandono", "id_cabotage_weight_list", 'bi bi-eye'], ["/actualizar-abandono", "id_cabotage_weight_list", 'bi bi-pencil-square'], ["/eliminar-entry-export", "id_cabotage_weight_list", 'bi bi-trash3']];
    }
    this.entry = {
      ...this.entry,
      ...this.entryForm.value
    };

    this.transportForm.get('no_ticket')?.valueChanges
    .pipe(
      debounceTime(500)
    )
    .subscribe( ticket => {
      this.isValidModule = false;
      const ticketNumber = Number(ticket);
      const original_scale_id: string = this.entryForm.get('original_scale_id')?.value;
      const transport_type_id: string = this.entryForm.get('transport_type_id')?.value;
      const isSybasa = Number(original_scale_id) === 2;
      const isRailway = Number(transport_type_id) === 3;
      this.ticketChangeCount++;
      if ((this.movimiento === 'actualizar' && this.ticketChangeCount <= 1) || original_scale_id == '3') {
        return;
      }
      if (isRailway && isSybasa) {
        return;
      }
      if (
        ticketNumber > 0 &&
        Number.isInteger(ticketNumber) &&
        this.updateTranpostForm &&
        !this.qrResultString &&
        !this.scannerTextArea.value
      ) {
        this.loaderTicket = true;
        if (original_scale_id == '1') {
          this.hangleTicketTruckCooper(ticketNumber);
        } else if (original_scale_id == '2') {
          this.hangleTicketTruckSybasa(ticketNumber);
        }
      }
    });

    this.entryForm.get('railway_group')?.valueChanges.pipe(
      debounceTime(500)
    ).subscribe( value => {
      if (value && this.movimiento === 'crear') {
        this.hangleRailwayGroup(value);
      }
    });

    if (this.router.url.includes('entry-list')) {
      this.entryForm.reset({
        ...this.entryDetalle[0],
        admission_date: this.entryDetalle[0]?.admission_date.substring(0, 10),
      });
      if (this.movimiento === 'actualizar') {
        this.entryForm.get('entry_type_id')?.disable();
        this.entryForm.get('railway_group')?.disable();
        this.changeTransport();
      }
      this.setTotalTonsPieces();
      this.updateTotals(this.transportList);
      this.updateValidators(this.entryForm.get('transport_type_id')?.value)
      if (this.entryForm.get('transport_type_id')?.value == 2) {
        this.entryTonnage = Number(this.entryForm.get('total_weight')?.value);
        this.entryPieces = Number(this.entryForm.get('total_pieces')?.value);
      }
      if (this.entryDetalle[0].id) {
        this.id = this.entryDetalle[0].id;
      }
      if (this.movimiento === 'detalle') {
        this.entryForm.disable();
      }
      this.entryForm.get('transport_type_id')?.disable();
    }
    this.entryForm.get('precinct_key')?.disable();

    this.transportLine.valueChanges.pipe(
      debounceTime(500)
    ).subscribe( value => {
      this.getTransportLines(value.toUpperCase());
    });

    this.formTransportLine.valueChanges
    .subscribe( value => {
      if (value) {
        this.entryForm.get('transport_line')?.setValue(value);
      }
    });

    this.entryForm.get('total_weight')?.valueChanges
    .subscribe( value => {
      if (value) {
        this.entryTonnage = Number(value);
      } else {
        this.entryTonnage = 0;
      }
    });

    this.entryForm.get('total_pieces')?.valueChanges
    .subscribe( value => {
      if (value) {
        this.entryPieces = Number(value);
      } else {
        this.entryPieces = 0;
      }
    });
  }

  /**
   * Valida y envía el formulario para crear o actualizar la entrada por transporte del lote de cabotaje,
   * verificando los registros de transporte y mostrando los mensajes de éxito o error.
   */
  saveEntry() {
    if (!this.authService.isValidPath('cabotage', 'entries', 'create')) {
      return;
    }
    const invalidLocationsForm = this.amountsComponent.isInvalidForm();
    if (this.entryForm.invalid || invalidLocationsForm) {
      this.entryForm.markAllAsTouched();
      this.mensajeOverlay = 'Favor de verificar la información';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.buttons = false;
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },2000)
      return;
    }
    const transportType = this.entryForm.get('transport_type_id')?.value;
    if (transportType != 2 && !this.transportList.length) {
      this.mensajeOverlay = 'Favor de agregar un registro de transporte';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },4000);
      return;
    }
    const trailer = this.entryForm.get('trailer_id')?.value;
    if (transportType == 1 && trailer == 1 && this.transportList.length > 1) {
      this.mensajeOverlay = 'Favor de eliminar un registro de transporte';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },4000);
      return;
    }
    this.loading = true;
    let newList = [...this.transportList.map(item => ({
      file_ticket: item.file_ticket,
      gross_weight: item.gross_weight,
      no_ticket: item.no_ticket ? String(item.no_ticket) : null,
      plate: item.plate,
      quantity_pieces: item.quantity_pieces,
      tare_weight: item.tare_weight,
      origin_weight: item.origin_weight,
      no_slab: item.no_slab,
      no_cast: item.no_cast,
    }))];
    this.entry = {
      ...this.entry,
      ...this.entryForm.value,
      cabotage_batch_id: this.batchValue,
      entry_type_id: Number(this.tipoEntrada.value),
      transport_type_id: Number(this.entryForm.get('transport_type_id')?.value),
      trailer_id: Number(this.entryForm.get('transport_type_id')?.value) === 1 ? Number(this.entryForm.get('trailer_id')?.value) : null,
      original_scale_id: Number(this.entryForm.get('original_scale_id')?.value) || null,
      location_id: Number(this.entryForm.get('location_id')?.value) || null,
      transport_line: Number(this.entryForm.get('transport_line')?.value) || null,
      railway_group: this.entryForm.get('railway_group')?.value ? Number(this.entryForm.get('railway_group')?.value) : null,
      admission_date: this.entryForm.get('admission_date')?.value + ' 00:00:00',
      ship_number: this.entryForm.get('ship_number')?.value ? Number(this.entryForm.get('ship_number')?.value) : null,
      total_weight: this.entryForm.get('total_weight')?.value ? Number(this.entryForm.get('total_weight')?.value) : 1,
      total_pieces: this.entryForm.get('total_pieces')?.value ? Number(this.entryForm.get('total_pieces')?.value) : 1,
      checker_name: this.entryForm.get('checker_name')?.value || '',
    };
    if (this.movimiento === 'actualizar') {
      this.entry = {
        ...this.entry,
        id: this.entryDetalle[0].id,
        original_scale_id: this.entryForm.get('transport_type_id')?.value != 2 ?
          Number(this.entryForm.get('original_scale_id')?.value) || 1 : undefined,
      };
      this.loteCabotajeService.updateCabotageEntry(this.entry)
      .subscribe({
        next: response => {
          if (response.error) {
            this.loading = false;
            this.mensajeOverlay = response.message.includes('tonnage')
            ? 'La suma de toneladas de entrada es mayor a las toneladas del lote'
            : response.message.includes('pieces')
            ? 'La suma de piezas es mayor a las piezas totales del lote'
            : 'Lo sentimos no fue posible actualizar la entrada, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.buttons = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 4000);
            return;
          }
          this.loteCabotajeService.getCabotageBatch(this.batchValue)
          .subscribe({
            next: batch => {
              this.loteCabotajeService.loteInfoCabotage = batch[0];
              this.loading = false;
              this.mensajeOverlay = 'La entrada fue actualizada de manera correcta';
              this.iconoOverlay = 'bi bi-check2';
              this.buttons = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
                this.regresar();
              }, 2000);
            },
            error: (e) => {
              this.loading = false;
              this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
              this.iconoOverlay = 'bi bi-exclamation-circle-fill';
              this.buttons = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
                this.regresar();
              }, 3000);
            },
          });
        },
        error: (e) => {
          this.loading = false;
          this.mensajeOverlay = 'Error en el servidor al actualizar el registro, inténtelo más tarde';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
      return;
    }
    if (transportType != 2) {
      this.entry.total_weight = 1;
      this.entry.total_pieces = 1;
    }
    this.entry.weight_list = [...newList];
    this.loteCabotajeService.createCabotageEntry(this.entry)
    .subscribe({
      next: response => {
        if (response.error) {
          this.mensajeOverlay = response.message.includes('tonnage')
          ? 'La suma de toneladas liberadas es mayor a las toneladas del lote'
          : response.message.includes('pieces')
          ? 'La suma de piezas es mayor a las piezas totales del lote'
          : 'Lo sentimos no fue posible agregar la entrada, inténtelo más tarde';
          this.loading = false;
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 4000);
          return;
        }
        this.loteCabotajeService.getCabotageBatch(this.batchValue)
        .subscribe({
          next: batch => {
            this.loteCabotajeService.loteInfoCabotage = batch[0];
            this.loading = false;
            this.mensajeOverlay = 'La entrada fue agregada de manera correcta';
            this.iconoOverlay = 'bi bi-check2';
            this.buttons = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
              if (this.router.url.includes('ship-list')) {
                this.router.navigate([`ship-list/${this.blDetails.operation_number}/cabotage/batch-movement/entry-list`, this.batchValue]);
              } else {
                this.router.navigate([`/cabotage/batch-movement/entry-list`, this.batchValue])
              }
            }, 2000);
          },
          error: (e) => {
            this.loading = false;
            this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.buttons = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
              this.regresar();
            }, 3000);
          },
        });
      },
      error: (e) => {
        this.loading = false;
        this.mensajeOverlay = 'Error en el servidor al crear el registro, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Indica si un campo del formulario de entrada es inválido y ha sido tocado por el usuario.
   * @param campo - Nombre del control del formulario a validar.
   * @returns `true` si el campo tiene errores y fue tocado; de lo contrario `null` o `false`.
   */
  campoEsValido( campo: string): boolean | null {
    return this.entryForm.get(campo)!.errors &&
    this.entryForm.get(campo)!.touched;
  }

  /**
   * Obtiene la fecha actual con formato `YYYY-MM-DD`.
   * @returns La fecha actual como cadena de texto.
   */
  getDate(): string {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const date = `${year}-${month}-${day}`;
    return date;
  }

  /**
   * Ordena un arreglo de manera ascendente según la clave indicada.
   * @param array - Arreglo de elementos a ordenar.
   * @param key - Clave del elemento por la cual se ordena.
   * @returns El arreglo ordenado.
   */
  sortArray<T>(array: T[], key: keyof T): T[] {
    return array = array.sort(function (a, b) {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      return 0;
    });
  }

  /**
   * Emite el evento para regresar a la vista anterior del flujo de entradas.
   */
  regresar() {
    this.onRegresar.emit(true);
  }

  /**
   * Alterna la visibilidad del overlay de selección de línea de transporte
   * cuando el movimiento es de creación o actualización.
   */
  togleOverlayTransportLine() {
    if (this.movimiento === 'crear' || this.movimiento === 'actualizar') {
      this.transportLineOverlay = !this.transportLineOverlay;
    }
  }

  /**
   * Filtra la lista de líneas de transporte por la descripción que contenga el valor indicado.
   * @param value - Texto de búsqueda para filtrar las líneas de transporte.
   */
  getTransportLines(value: string) {
    this.loaderTransportLine = true;
    this.listTransportLineFilter = this.listTransportLine.filter( transportLine => {
      return transportLine.description.includes(value);
    });
    this.loaderTransportLine = false;
  }

    fileInput(event: any, campo: string): void {
    if (event.target.files[0]) {
      if (event.target.files[0].size > 15 * 1024 * 1024) {
        switch (campo) {
          case 'cabotage_entrance_ticket':
            this.mensajeError = 'El archivo tiene que ser menos a 15mb';
            this.maxSize = true;
            break;
        }
        this.entryForm.get(campo)?.setValue('');
        return;
      }
      this.maxSize = false;
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const cadena = reader.result?.toString() || '';
        const contenidoBase64 = cadena.split(',')[1];
        this.entryForm.get(campo)?.setValue(contenidoBase64);
      }
    } else {
      switch (campo) {
        case 'cabotage_entrance_ticket':
          this.mensajeError = 'Ingrese el archivo';
          break;
      }
      this.entryForm.get(campo)?.setValue('');
    }
  }

  /**
   * Consulta el ticket de báscula de Cooper por su número y rellena el formulario de transporte
   * con los pesos y placas obtenidos, validando que sea un ticket de cabotaje válido.
   * @param ticketNumber - Número de folio del ticket de báscula a consultar.
   */
  hangleTicketTruckCooper(ticketNumber: number) {
    this.scaleTicketSvc.getScaleTicket(ticketNumber)
    .subscribe({
      next: scaleTicket => {
        if ( Array.isArray(scaleTicket) && scaleTicket.length ) {
          if (scaleTicket[0].operation_type !== 3) {
            this.resetTransportForm();
            this.messageTicket = 'Número de folio ticket no válido para cabotaje';
            this.isValidModule = true;
            this.loaderTicket = false;
            return;
          }
          if (scaleTicket[0].status === false) {
            this.resetTransportForm();
            this.messageTicket = 'Boleta de báscula en captura';
            this.isValidModule = true;
            this.loaderTicket = false;
            return;
          }
          if (scaleTicket[0].status_ticket === false) {
            this.resetTransportForm();
            this.messageTicket = 'Boleta de báscula cancelada';
            this.isValidModule = true;
            this.loaderTicket = false;
            return;
          }
          this.transportForm.get('origin_weight')?.setValue(Number(scaleTicket[0].origin_weight) > 0 ? Number(scaleTicket[0].origin_weight) / 1000 : 0);
          this.transportForm.get('gross_weight')?.setValue(Number(scaleTicket[0].gross_weight) > 0 ? Number(scaleTicket[0].gross_weight) / 1000 : 0);
          this.transportForm.get('tare_weight')?.setValue(Number(scaleTicket[0].tare_weight) > 0 ? Number(scaleTicket[0].tare_weight) / 1000 : 0);
          this.transportForm.get('plate')?.setValue(scaleTicket[0].plates);
          this.weightTransportChange();
        } else {
          this.resetTransportForm();
          this.messageTicket = 'Número de folio ticket no existe';
          this.isValidModule = true;
        }
        this.loaderTicket = false;
      },
      error: (e) => {
        this.mensajeOverlay = 'Error en el servidor al cargar el ticket, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Consulta el ticket de báscula de Sybasa por su número y rellena el formulario de transporte
   * con los pesos y placas obtenidos.
   * @param ticketNumber - Número de folio del ticket de báscula a consultar.
   */
  hangleTicketTruckSybasa(ticketNumber: number) {
    const admission_date = new Date(this.entryForm.get('admission_date')?.value);
    const year = admission_date.getFullYear();
    this.scaleTicketSvc.getScaleTicketTruckSybasa({
      transport_type_id: 1,
      ticket_number: ticketNumber,
      scale_key: 'SYBC',
      year: year
    }).subscribe({
      next: scaleTicketSybasa => {
        if ( Array.isArray(scaleTicketSybasa) && scaleTicketSybasa.length ) {
          this.transportForm.get('origin_weight')?.setValue(Number(scaleTicketSybasa[0].origin_weight) > 0 ? Number(scaleTicketSybasa[0].origin_weight) / 1000 : 0);
          this.transportForm.get('gross_weight')?.setValue(Number(scaleTicketSybasa[0].gross_weight) > 0 ? Number(scaleTicketSybasa[0].gross_weight) / 1000 : 0);
          this.transportForm.get('tare_weight')?.setValue(Number(scaleTicketSybasa[0].tare_weight) > 0 ? Number(scaleTicketSybasa[0].tare_weight) / 1000 : 0);
          this.transportForm.get('plate')?.setValue(scaleTicketSybasa[0].plates);
          this.weightTransportChange();
        } else {
          this.resetTransportForm();
          const response: any = scaleTicketSybasa;
          if (response.error) {
            this.loaderTicket = false;
            this.mensajeOverlay = 'Error en el servidor al cargar el ticket, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
            return;
          }
          this.messageTicket = 'Número de folio ticket no existe';
          this.isValidModule = true;
        }
        this.loaderTicket = false;
      },
      error: e => {
        this.loaderTicket = false;
        this.mensajeOverlay = 'Error en el servidor al cargar el ticket, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      }
    });
  }

  /**
   * Consulta los tickets de báscula de un grupo ferroviario de Sybasa y carga los registros de transporte asociados.
   * @param value - Número del grupo ferroviario a consultar.
   */
  hangleRailwayGroup(value: any) {
    if (!this.entryForm.get('admission_date')?.value) {
      this.entryForm.get('railway_group')?.setValue('');
      this.mensajeOverlay = 'Ingrese la fecha';
      this.iconoOverlay = 'bi bi-info-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },2000);
      return;
    }
    const admission_date = new Date(this.entryForm.get('admission_date')?.value);
    const year = admission_date.getFullYear();
    this.loaderRailwayGroup = true;
    this.scaleTicketSvc.getScaleTicketRailwaySybasa({
      transport_type_id: 2,
      ticket_number: Number(value),
      scale_key: 'SYBC',
      year: year
    }).subscribe({
      next: scaleTicketsRailway => {
        if (!Array.isArray(scaleTicketsRailway)) {
          this.loaderRailwayGroup = false;
          this.mensajeOverlay = 'Error en la base de datos, favor de intentarlo de nuevo';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          },2000);
          return;
        }
        this.transportList = [];
        scaleTicketsRailway.forEach( (ticket, index) => {
          this.transportList.push({
            id: index,
            origin_weight: 0,
            gross_weight: Number(ticket.gross_weight) > 0 ? ticket.gross_weight / 1000 : 0,
            tare_weight:  Number(ticket.tare_weight) > 0 ? ticket.tare_weight / 1000 : 0,
            quantity_pieces: 0,
            plate: ticket.unit + ticket.number,
            no_ticket: ticket.id,
            file_ticket: null,
            no_slab: null,
            no_cast: null,
            net_weight: Number(ticket.net_weight) > 0 ? ticket.net_weight / 1000 : 0
          });
        });
        this.setTotalTonsPieces();
        this.updateTotals(this.transportList);
        this.loaderRailwayGroup = false;
      },
      error: e => {
        this.loaderRailwayGroup = false;
        this.mensajeOverlay = 'Error en el servidor al cargar los tickets, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      }
    });
  }

  // Create transport
  /**
   * Habilita el formulario de transporte y muestra el overlay para crear un nuevo registro de transporte.
   */
  showCreateTransport() {
    this.transportForm.enable();
    this.overlayTransport = !this.overlayTransport;
  }

  /**
   * Prepara y muestra el formulario para crear un nuevo registro de transporte.
   */
  createTransport() {
    this.updateTranpostForm = true;
    this.transportForm.enable();
    this.updateTransport = false;
    this.addTransport = true;
    this.transportForm.reset();
    this.transportForm.reset({
      quantity_pieces: 0,
    });
    this.net_weight = 0;
    const transportType = this.entryForm.get('transport_type_id')?.value;
    const trailerType = this.entryForm.get('trailer_id')?.value;
    const originTicket = this.entryForm.get('original_scale_id')?.value;
    const admission_date = this.entryForm.get('admission_date')?.value;
    if (!admission_date) {
      this.mensajeOverlay = 'Ingrese la fecha';
      this.iconoOverlay = 'bi bi-info-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },2000);
      return;
    }
    if (!transportType) {
      this.mensajeOverlay = 'Selecciona un tipo de transporte';
      this.iconoOverlay = 'bi bi-info-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },3000);
      return;
    }
    if (!originTicket) {
      this.mensajeOverlay = 'Selecciona un tipo de báscula';
      this.iconoOverlay = 'bi bi-info-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },3000);
      return;
    }
    if (transportType == '3') {
      this.overlayTransport = !this.overlayTransport;
    }
    if (transportType == '1') {
      if (trailerType == '1') {
        if (!this.transportList.length) {
          this.overlayTransport = !this.overlayTransport;
        } else {
          this.mensajeOverlay = 'No es posible agregar otro registro cuando remolque es sencillo';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          },4000);
          return;
        }
      } else if (trailerType == '2') {
        if (this.transportList.length < 2) {
          this.overlayTransport = !this.overlayTransport;
        } else {
          this.mensajeOverlay = 'No es posible agregar otro registro cuando remolque es full';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          },4000);
          return;
        }
      } else {
        this.mensajeOverlay = 'Selecciona un tipo de remolque';
        this.iconoOverlay = 'bi bi-info-circle-fill';
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        },3000);
        return;
      }
    }
  }

  /**
   * Muestra la confirmación para crear el registro de transporte.
   */
  confirmCreateForm() {
    this.confirmCreate = true;
  }

  /**
   * Guarda o cancela el registro de transporte capturado según la acción indicada.
   * @param cancel - Indicador que determina si se cancela la operación.
   */
  saveTransport(cancel: string) {
    this.confirmCreate = false;
    if (cancel) {
      return;
    }
    if( this.transportForm.invalid ) {
      this.transportForm.markAllAsTouched();
      this.mensajeOverlay = 'Favor de verificar la información';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },2000);
      return;
    }
    if (this.net_weight <= 0) {
      this.mensajeOverlay = 'No es posible hacer un registro con tonelaje en 0 o menor';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },4000);
      return;
    }
    // if ( Number(this.transportForm.get('origin_weight')?.value) === 0 ) {
    //   this.mensajeOverlay = 'Peso origen no debe ser 0';
    //   this.iconoOverlay = 'bi bi-exclamation-circle-fill';
    //   this.overlay = true;
    //   setTimeout(() => {
    //     this.overlay = false;
    //   },4000);
    //   return;
    // }
    this.showCreateTransport();
    if (this.movimiento === 'actualizar') {
      const file = this.transportForm.get('file_ticket')?.value || '';
      const transport: ExportTransportCreate = {
        ...this.transportForm.value,
        entry_id: this.entryDetalle[0].id,
        type_output_id: 0,
        quantity_pieces: this.transportForm.get('quantity_pieces')?.value ? Number(this.transportForm.get('quantity_pieces')?.value) : 0,
        gross_weight: Number(this.transportForm.get('gross_weight')?.value),
        tare_weight: Number(this.transportForm.get('tare_weight')?.value),
        origin_weight: Number(this.transportForm.get('origin_weight')?.value),
        file_ticket: file
      };
      this.loading = true;
      if (this.addTransport) {
        this.loteCabotajeService.createCabotageTransport(transport)
        .subscribe({
          next: response => {
            if (response.error) {
            this.loading = false;
              this.mensajeOverlay = response.message.includes('tonnage')
                ? 'La suma de toneladas de salidas es mayor a las toneladas de entrada'
                : response.message.includes('pieces')
                ? 'La suma de piezas de salidas es mayor a las piezas del entrada'
                : 'Lo sentimos no fue posible crear el registro, inténtelo más tarde';
              this.iconoOverlay = 'bi bi-exclamation-circle-fill';
              this.loading = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
              },4000);
              return;
            }
            this.loteCabotajeService.getCabotageBatch(this.batchValue)
            .subscribe({
              next: batch => {
                this.loteCabotajeService.loteInfoCabotage = batch[0];
                const idOutput = this.entryDetalle[0].id || 0;
                this.loteCabotajeService.getCabotageTransportsByOutput(idOutput)
                .subscribe({
                  next: transports => {
                    this.transportList = [...transports];
                    this.setTotalTonsPieces();
                    this.updateTotals(this.transportList);
                    this.mensajeOverlay = 'Registro agregado correctamente';
                    this.iconoOverlay = 'bi bi-check2';
                    this.loading = false;
                    this.overlay = true;
                    setTimeout(() => {
                      this.overlay = false;
                      this.net_weight = 0;
                      this.transportForm.reset({
                        quantity_pieces: 0
                      });
                    },2000);
                  },
                  error: (e) => {
                    this.loading = false;
                    this.mensajeOverlay = 'Error en el servidor al cargar los transportes, inténtelo más tarde';
                    this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                    this.buttons = false;
                    this.overlay = true;
                    setTimeout(() => {
                      this.overlay = false;
                    }, 3000);
                  },
                });
              },
              error: (e) => {
                this.loading = false;
                this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
                this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                this.buttons = false;
                this.overlay = true;
                setTimeout(() => {
                  this.overlay = false;
                }, 3000);
              },
            });
          },
          error: (e) => {
            this.loading = false;
            this.mensajeOverlay = 'Error en el servidor al crear el registro, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.buttons = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
          },
        });
        return;
      } else {
        transport.id_cabotage_weight_list= this.currentIdTransport;
        this.loteCabotajeService.updateCabotageTransport(transport)
        .subscribe({
          next: response => {
            if (response.error) {
            this.loading = false;
              this.mensajeOverlay = response.message.includes('tonnage')
                ? 'La suma de toneladas de salidas es mayor a las toneladas de entrada'
                : response.message.includes('pieces')
                ? 'La suma de piezas de salidas es mayor a las piezas del entrada'
                : 'Lo sentimos no fue posible actualizar el registro, inténtelo más tarde';
              this.iconoOverlay = 'bi bi-exclamation-circle-fill';
              this.loading = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
              },4000);
              return;
            }
            this.loteCabotajeService.getCabotageBatch(this.batchValue)
            .subscribe({
              next: batch => {
                this.loteCabotajeService.loteInfoCabotage = batch[0];
                const idOutput = this.entryDetalle[0].id || 0;
                this.loteCabotajeService.getCabotageTransportsByOutput(idOutput)
                .subscribe({
                  next: transports => {
                    this.transportList = [...transports];
                    this.setTotalTonsPieces();
                    this.updateTotals(this.transportList);
                    this.mensajeOverlay = 'Registro actualizado correctamente';
                    this.iconoOverlay = 'bi bi-check2';
                    this.loading = false;
                    this.overlay = true;
                    setTimeout(() => {
                      this.overlay = false;
                      this.net_weight = 0;
                      this.transportForm.reset({
                        quantity_pieces: 0
                      });
                    },2000);
                  },
                  error: (e) => {
                    this.loading = false;
                    this.mensajeOverlay = 'Error en el servidor al cargar los transportes, inténtelo más tarde';
                    this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                    this.buttons = false;
                    this.overlay = true;
                    setTimeout(() => {
                      this.overlay = false;
                    }, 3000);
                  },
                });
              },
              error: (e) => {
                this.loading = false;
                this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
                this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                this.buttons = false;
                this.overlay = true;
                setTimeout(() => {
                  this.overlay = false;
                }, 3000);
              },
            });
          },
          error: (e) => {
            this.loading = false;
            this.mensajeOverlay = 'Error en el servidor al actualizar el registro, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.buttons = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
          },
        });
        return;
      }
    }
    this.net_weight = Number(this.transportForm.get('gross_weight')?.value) - Number(this.transportForm.get('tare_weight')?.value);
    const transport = {
      id: this.idCount,
      ...this.transportForm.value,
      net_weight: this.net_weight,
      quantity_pieces: this.transportForm.get('quantity_pieces')?.value ? Number(this.transportForm.get('quantity_pieces')?.value) : 0,
      gross_weight: Number(this.transportForm.get('gross_weight')?.value),
      tare_weight: Number(this.transportForm.get('tare_weight')?.value),
      origin_weight: Number(this.transportForm.get('origin_weight')?.value),
    };
    this.idCount++;
    this.net_weight = 0;
    this.transportForm.reset({
      quantity_pieces: 0
    });
    if (this.addTransport) {
      this.transportList.push({...transport});
      this.mensajeOverlay = 'Registro agregado correctamente';
    } else {
      this.mensajeOverlay = 'Registro actualizado correctamente';
      const index = this.transportList.findIndex( transport => transport.id === this.currentIdTransport );
      this.transportList[index] = {...transport, id: this.transportList[index].id };
    }
    this.setTotalTonsPieces();
    this.updateTotals(this.transportList);
    this.iconoOverlay = 'bi bi-check2';
    this.overlay = true;
    setTimeout(() => {
      this.overlay = false;
    },2000);
  }

  /**
   * Marca un registro de transporte para su eliminación mostrando la confirmación correspondiente.
   * @param id - Identificador del registro de transporte a eliminar.
   */
  confirm(id: number) {
    this.currentTransportId = id;
    this.transportDelete = true;
  }

  /**
   * Elimina el registro de transporte previamente seleccionado o cancela la operación.
   * @param cancelar - Indicador que determina si se cancela la eliminación.
   */
  deleteTransport( cancelar: string ) {
    if ( cancelar ) {
      this.transportDelete = false;
      return;
    }
    this.transportDelete = false;
    if (this.movimiento === 'actualizar') {
      if (this.transportList.length === 1) {
        this.mensajeOverlay = 'Tiene que haber por lo menos un registro';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.loading = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        },4000);
        return;
      }
      this.loading = true;
      const idEntry = this.entryDetalle[0].id || 0;
      this.loteCabotajeService.deleteCabotageTransport(this.currentTransportId, idEntry)
      .subscribe({
        next: response => {
          if (response.error) {
            this.mensajeOverlay = 'Lo sentimos no fue posible eliminar el registro, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-info-circle-fill';
            this.loading = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            },4000);
            return;
          }
          this.loteCabotajeService.getCabotageBatch(this.batchValue)
          .subscribe({
            next: batch => {
              this.loteCabotajeService.loteInfoCabotage = batch[0];
              const idOutput = this.entryDetalle[0].id || 0;
              this.loteCabotajeService.getCabotageTransportsByOutput(idOutput)
              .subscribe({
                next: transports => {
                  this.transportList = [...transports];
                  this.setTotalTonsPieces();
                  this.updateTotals(this.transportList);
                  this.mensajeOverlay = 'Registro eliminado correctamente';
                  this.iconoOverlay = 'bi bi-check2';
                  this.loading = false;
                  this.overlay = true;
                  setTimeout(() => {
                    this.overlay = false;
                  },2000);
                },
                error: (e) => {
                  this.loading = false;
                  this.mensajeOverlay = 'Error en el servidor al cargar los transportes, inténtelo más tarde';
                  this.iconoOverlay = 'bi bi-exclamation-circle-fill';
                  this.buttons = false;
                  this.overlay = true;
                  setTimeout(() => {
                    this.overlay = false;
                  }, 3000);
                },
              });
            },
            error: (e) => {
              this.loading = false;
              this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
              this.iconoOverlay = 'bi bi-exclamation-circle-fill';
              this.buttons = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
              }, 3000);
            },
          });
        },
        error: (e) => {
          this.loading = false;
          this.mensajeOverlay = 'Error en el servidor al eliminar el registro, inténtelo más tarde';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
      return;
    }
    const index = this.transportList.findIndex( item => item.id === this.currentTransportId);
    this.transportList.splice(index, 1);
    this.transportDelete = false;
    this.transportForm.markAllAsTouched();
    this.setTotalTonsPieces();
    this.updateTotals(this.transportList);
    this.mensajeOverlay = 'Registro eliminado correctamente';
    this.iconoOverlay = 'bi bi-check2';
    this.overlay = true;
    setTimeout(() => {
      this.overlay = false;
    },2000);
  }

  /**
   * Elimina todos los registros de transporte de la entrada o cancela la operación.
   * @param cancel - Indicador que determina si se cancela la eliminación masiva.
   */
  deleteAllTransport(cancel: string) {
    this.overlay = false;
    if (cancel) {
      this.entryForm.get('original_scale_id')?.setValue(this.entryDetalle[0].original_scale_id);
      return;
    } else {
      this.entryDetalle[0].original_scale_id = this.entryForm.get('original_scale_id')?.value;
    }
    this.buttons = false;
    this.loading = true;
    this.loteCabotajeService.deleteAllCabotageTransportEntry(this.entryDetalle[0].id || 0)
    .subscribe({
      next: response => {
        if (response.error) {
          this.mensajeOverlay = 'Lo sentimos no fue posible eliminar los registros, inténtelo más tarde';
          this.iconoOverlay = 'bi bi-info-circle-fill';
          this.loading = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          },4000);
          return;
        }
        this.transportList = [];
        this.setTotalTonsPieces();
        this.updateTotals(this.transportList);
        this.loteCabotajeService.getCabotageBatch(this.batchValue)
        .subscribe({
          next: batch => {
            this.loteCabotajeService.loteInfoCabotage = batch[0];
            this.mensajeOverlay = 'Registros eliminados correctamente';
            this.iconoOverlay = 'bi bi-check2';
            this.loading = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            },2000);
          },
          error: (e) => {
            this.loading = false;
            this.mensajeOverlay = 'Error en el servidor al obtener el lote, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
          },
        });
      },
      error: (e) => {
        this.loading = false;
        this.mensajeOverlay = 'Error en el servidor al eliminar los registros, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Descarga el archivo asociado a un registro de transporte de la entrada.
   * @param id - Identificador del archivo de transporte a descargar.
   */
  downloadFile(id: number) {
    const idEntry = this.entryDetalle[0].id || 0;
    this.loteCabotajeService.getCabotageTransportFile(idEntry, id)
    .subscribe({
      next: file => {
        if (file.url) {
          window.open(file.url, '_blank');
        } else {
          this.mensajeOverlay = 'Este registro no tiene asignado un archivo';
          this.iconoOverlay = 'bi bi-info-circle-fill';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 4000);
        }
      },
      error: (e) => {
        this.loading = false;
        this.mensajeOverlay = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Indica si un campo del formulario de transporte es inválido y ha sido tocado por el usuario.
   * @param campo - Nombre del control del formulario de transporte a validar.
   * @returns `true` si el campo tiene errores y fue tocado; de lo contrario `null` o `false`.
   */
  isValidTransport( campo: string): boolean | null {
    return this.transportForm.get(campo)!.errors &&
    this.transportForm.get(campo)!.touched;
  }

  /**
   * Procesa el archivo seleccionado para un campo del formulario de transporte, validando su tamaño
   * y convirtiéndolo a base64.
   * @param event - Evento del input de tipo archivo.
   * @param campo - Nombre del control del formulario donde se asigna el archivo.
   */
  fileInputTransport(event: any, campo: string): void {
    if (event.target.files[0]) {
      if (event.target.files[0].size > 15 * 1024 * 1024) {
        switch (campo) {
          case 'file_ticket':
            this.mensajeError = 'El archivo tiene que ser menos a 15mb';
            this.maxSize = true;
            break;
        }
        this.transportForm.get(campo)?.setValue('');
        return;
      }
      this.maxSize = false;
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const cadena = reader.result?.toString() || '';
        const contenidoBase64 = cadena.split(',')[1];
        this.transportForm.get(campo)?.setValue(contenidoBase64);
      };
    } else {
      switch (campo) {
        case 'file_ticket':
          this.mensajeError = 'Ingrese el archivo del ticket';
          break;
      }
      this.transportForm.get(campo)?.setValue('');
    }
  }

  /**
   * Calcula el peso neto del transporte a partir del peso bruto y la tara capturados.
   */
  weightTransportChange() {
    if (this.transportForm.get('gross_weight')?.value !== null && this.transportForm.get('tare_weight')?.value !== null) {
      let neto = Number(this.transportForm.get('gross_weight')?.value) - Number(this.transportForm.get('tare_weight')?.value);
      neto = Number(neto.toFixed(3));
      this.net_weight = neto;
    }
  }

  /**
   * Ajusta los validadores y campos del formulario en función del tipo de transporte seleccionado.
   */
  changeTransport() {
    const transportType = this.entryForm.get('transport_type_id')?.value;
    this.entryForm.get('trailer_id')?.clearValidators();
    this.entryForm.get('tractor_plates')?.clearValidators();
    this.entryForm.get('operator_name')?.clearValidators();

    if (this.movimiento === 'crear') {
      this.entryForm.get('trailer_id')?.setValue('');
      this.entryForm.get('tractor_plates')?.setValue('');
      this.entryForm.get('operator_name')?.setValue('');
      this.transportList = [];
      this.changeOriginTicket();
      this.entryForm.reset();
      this.updateValidators(transportType);
      this.transportList = [];
      this.entryForm.get('transport_type_id')?.setValue(transportType)
      this.entryForm.get('precinct_key')?.setValue(201)
      this.entryForm.get('checker_name')?.setValue(this.localStorageSvc.getFullName())
      this.entryForm.get('admission_date')?.setValue(this.getDate())
    }
    if (transportType == '1') {
      this.entryForm.get('trailer_id')?.addValidators([Validators.required]);
      this.entryForm.get('operator_name')?.addValidators([Validators.required]);
      this.entryForm.get('tractor_plates')?.addValidators([Validators.required]);
    }
    this.entryForm.get('trailer_id')?.updateValueAndValidity();
    this.entryForm.get('tractor_plates')?.updateValueAndValidity();
    this.entryForm.get('operator_name')?.updateValueAndValidity();
    if (transportType == '2' && this.router.url.includes('ship-list') && this.movimiento === 'crear') {
      this.entryForm.get('ship_number')?.setValue(String(this.blDetails?.operation_number) || '');
      this.entryForm.get('ship_name')?.setValue(this.blDetails?.boats_name);
    }
  }

  /**
   * Reacciona al cambio de báscula de origen reiniciando los registros de transporte cuando corresponde.
   */
  changeOriginTicket() {
    if (this.movimiento === 'actualizar') {
      if (this.transportList.length) {
        this.mensajeOverlay = 'Esta acción eliminará todos los registros de transporte. ¿Está seguro?';
        this.iconoOverlay = '';
        this.buttons = true;
        this.overlay = true;
      } else {
        this.entryDetalle[0].original_scale_id = this.entryForm.get('original_scale_id')?.value;
      }
    }
    this.entryForm.get('railway_group')?.clearValidators();
    this.entryForm.get('railway_group')?.setValue('');
    const currentOriginTicket = this.entryForm.get('original_scale_id')?.value;
    const currentTransportType = this.entryForm.get('transport_type_id')?.value;
    // Agregar validacion cuando es sibasa y ferrocarril
    if (currentOriginTicket == '2' && currentTransportType == '3') {
      this.entryForm.get('railway_group')?.addValidators([Validators.required]);
    }
    this.entryForm.get('railway_group')?.updateValueAndValidity();
  }

  /**
   * Descarga el ticket de báscula asociado a un registro de transporte.
   * @param id - Identificador del registro de transporte cuyo ticket se descarga.
   */
  downloadTicket(id: number) {
    const transport = this.transportList.find( transport => transport.id_cabotage_weight_list === id );
    this.loading = true;
    if (transport) {
      const id_ticket = this.entryForm.get('original_scale_id')?.value != 3 ? Number(transport.no_ticket) || null : null;
      const id_weight = this.entryForm.get('original_scale_id')?.value == 3 ? Number(transport.id_cabotage_weight_list) || null : null;
      const genericTicket: GenericTicket = {
        module_id: Module.cabotage,
        operation_type: OperationType.entry,
        operation_id: this.id,
        id_ticket: id_ticket,
        id_weight: id_weight,
      };
      this.scaleTicketSvc.downloadGenericScaleTicket(genericTicket)
      .subscribe({
        next: response => {
          this.loading = false;
          if (response.url) {
            window.open(response.url, '_blank');
          } else {
            const message = this.entryForm.get('original_scale_id')?.value != 3 && !Number(transport.no_ticket) ?
              'Falta el folio del ticket' : 'Error al descargar el archivo, inténtelo más tarde'
            this.mensajeOverlay = message;
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            },3000);
          }
        },
        error: (e) => {
          this.loading = false;
          this.mensajeOverlay = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.loading = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          },3000);
        },
      });
    } else {
      this.loading = false;
      this.mensajeOverlay = 'Error al obtener información del transporte, inténtelo más tarde';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.loading = false;
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },3000);
    }
  }

  /**
   * Carga un registro de transporte en el formulario para mostrarlo o editarlo según la acción indicada.
   * @param id - Identificador del registro de transporte.
   * @param accion - Acción a realizar sobre el registro (por ejemplo, detalle o edición).
   */
  mostrarSalida(id: number, accion: string) {
    this.updateTranpostForm = true;
    this.ticketChangeCount = 0;
    this.addTransport = false;
    this.currentIdTransport = id;
    this.transportForm.enable();
    this.overlayTransport = true;
    if (this.movimiento !== 'crear') {
      const transport = this.transportList.find( transport => transport.id_cabotage_weight_list === id );
      this.transportForm.reset({
        ...transport
      });
      this.net_weight = transport.net_weight;
      if (accion === 'detalle') {
        this.updateTransport = false;
        this.transportForm.disable();
      } else {
        this.updateTransport = true;
      }
    } else {
      const transport = this.transportList.find( transport => transport.id === id );
      this.transportForm.reset({
        ...transport
      });
      this.net_weight = transport.net_weight;
      if (accion === 'detalle') {
        this.updateTransport = false;
        this.transportForm.disable();
      } else {
        this.updateTransport = true;
      }
    }
  }

  /**
   * Reinicia los campos del formulario de transporte a sus valores vacíos.
   */
  resetTransportForm() {
    this.transportForm.get('origin_weight')?.setValue(null);
    this.transportForm.get('gross_weight')?.setValue(null);
    this.transportForm.get('tare_weight')?.setValue(null);
    this.transportForm.get('plate')?.setValue(null);
    this.net_weight = 0;
  }

  /**
   * Calcula y asigna el total de toneladas y piezas a partir de los registros de transporte.
   */
  setTotalTonsPieces() {
    const {totalTons, totalPieces} = this.transportList.reduce( (totals, transport) => {
      totals.totalTons += transport.net_weight;
      totals.totalPieces += transport.quantity_pieces;
      return totals;
    }, {totalTons: 0, totalPieces: 0});
    this.entryTonnage = Number(totalTons) || 0;
    this.entryPieces = Number(totalPieces) || 0;
  }

  /**
   * Actualiza los validadores del formulario de entrada según el tipo de transporte seleccionado.
   * @param transportType - Identificador del tipo de transporte o `null` si no aplica.
   */
  updateValidators(transportType: string | null) {
    this.entryForm.get('transport_line')?.clearValidators();
    this.entryForm.get('original_scale_id')?.clearValidators();
    this.entryForm.get('ship_number')?.clearValidators();
    this.entryForm.get('ship_name')?.clearValidators();
    this.entryForm.get('total_weight')?.clearValidators();
    this.entryForm.get('total_pieces')?.clearValidators();
    this.entryForm.get('bl_number')?.clearValidators();
    this.entryForm.get('customs_agent')?.clearValidators();
    if (transportType == '2') {
      this.entryForm.get('ship_number')?.addValidators([Validators.required]);
      this.entryForm.get('ship_name')?.addValidators([Validators.required]);
      this.entryForm.get('total_weight')?.addValidators([Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]);
      this.entryForm.get('total_pieces')?.addValidators([Validators.required, Validators.pattern(/^\d{1,11}$/)]);
      this.entryForm.get('bl_number')?.addValidators([Validators.required]);
      this.entryForm.get('customs_agent')?.addValidators([Validators.required]);
    } else {
      this.entryForm.get('transport_line')?.addValidators([Validators.required, Validators.maxLength(100)]);
      this.entryForm.get('original_scale_id')?.addValidators([Validators.required]);
    }
    this.entryForm.get('transport_line')?.updateValueAndValidity();
    this.entryForm.get('original_scale_id')?.updateValueAndValidity();
    this.entryForm.get('ship_number')?.updateValueAndValidity();
    this.entryForm.get('ship_name')?.updateValueAndValidity();
    this.entryForm.get('total_weight')?.updateValueAndValidity();
    this.entryForm.get('total_pieces')?.updateValueAndValidity();
    this.entryForm.get('bl_number')?.updateValueAndValidity();
    this.entryForm.get('customs_agent')?.updateValueAndValidity();
  }

  // Read QR
  /**
   * Activa o desactiva el modo de lectura de código QR (lector, cámara o cerrar).
   * @param type - Tipo de escáner a utilizar.
   */
  togleReadQR(type: ScannerType) {
    if (this.transportForm.get('no_ticket')?.disabled) {
      return;
    }
    this.overlayScanner = !this.overlayScanner;
    this.scannerEnabled = this.overlayScanner && type === 'camera' ? true : false;
    this.gunScannerEnabled = this.overlayScanner && type === 'scanner' ? true : false;
    this.overlayTransport = this.overlayScanner ? false : true;
  }

  /**
   * Almacena las cámaras encontradas y selecciona la primera disponible para el escáner.
   * @param cameras - Lista de cámaras detectadas en el dispositivo.
   */
  onCamerasFound(cameras: MediaDeviceInfo[]) {
    this.camerasList = [...cameras];
    this.cameraSelected.setValue(this.camerasList[0].deviceId);
    this.selectedDevice = this.camerasList[0];
    this.scannerEnabled = true;
  }

  /**
   * Maneja el caso en que no se encuentran cámaras disponibles para el escáner.
   */
  onCamerasNotFound() {
    this.scannerEnabled = false;
    this.mensajeOverlay = 'No se encontraron cámaras';
    this.iconoOverlay = 'bi bi-info-circle-fill ';
    this.overlay = true;
    setTimeout(() => {
      this.overlay = false;
    }, 2000);
  }

  /**
   * Cambia la cámara activa del escáner según la cámara seleccionada.
   */
  changeCamera() {
    this.selectedDevice = this.getDeviceById(this.cameraSelected.value);
  }

  /**
   * Obtiene una cámara de la lista a partir de su identificador.
   * @param deviceId - Identificador del dispositivo de cámara.
   * @returns La cámara correspondiente o la primera disponible si no se encuentra.
   */
  getDeviceById(deviceId: string): MediaDeviceInfo {
    return this.camerasList.find( camera => camera.deviceId === deviceId) || this.camerasList[0];
  }

  /**
   * Procesa el resultado del escaneo de un código QR con la cámara.
   * @param resultString - Cadena de texto leída del código QR.
   */
  onCodeResult(resultString: string) {
    this.qrResultString = resultString;
    this.isValidQR = true;
    if (this.qrResultString) {
      this.hangleTextQR(this.qrResultString);
    }
    this.togleReadQR(ScannerType.Close);
    this.mensajeOverlay = this.isValidQR ? 'Lectura de boleta de báscula correcta' : 'Error al leer el código QR';
    this.iconoOverlay = this.isValidQR ? 'bi bi-check2' : 'bi bi-exclamation-circle-fill';
    this.overlay = true;
    setTimeout(() => {
      this.qrResultString = '';
      this.scannerTextArea.setValue(null);
      this.overlay = false;
    }, 2000);
  }

  /**
   * Procesa el texto del código QR ingresado manualmente al presionar Enter.
   */
  onEnterPressed() {
    const textQR: string = this.scannerTextArea.value;
    this.isValidQR = true;
    if (textQR && textQR.includes('&')) {
      this.hangleTextQR(textQR);
    } else {
      this.isValidQR = false;
    }
    this.togleReadQR(ScannerType.Close);
    this.mensajeOverlay = this.isValidQR ? 'Lectura de boleta de báscula correcta' : 'Error al leer el código QR';
    this.iconoOverlay = this.isValidQR ? 'bi bi-check2' : 'bi bi-exclamation-circle-fill';
    this.overlay = true;
    setTimeout(() => {
      this.qrResultString = '';
      this.scannerTextArea.setValue(null);
      this.overlay = false;
    }, 2000);
  }

  /**
   * Interpreta la cadena del código QR y asigna sus valores a los campos correspondientes del formulario.
   * @param textQR - Cadena de texto del código QR a interpretar.
   */
  hangleTextQR(textQR: string) {
    const valuesQR: any = textQR.split('&');
    // Logica para leer string y asignarlo a los campos
    if (valuesQR[11] && !isNaN(parseInt(valuesQR[11].charAt(0), 10))) {
      // Boleta del sistema de inventarios nuevo
      this.transportForm.get('gross_weight')?.setValue(valuesQR[11].replace(',', '') > 0 ? Number(valuesQR[11].replace(',', '')) / 1000 : 0);
      this.transportForm.get('tare_weight')?.setValue(valuesQR[12].replace(',', '') > 0 ? Number(valuesQR[12].replace(',', '')) / 1000 : 0);
      this.net_weight = valuesQR[13].replace(',', '') > 0 ? Number(valuesQR[13].replace(',', '')) / 1000 : 0;
      this.transportForm.get('origin_weight')?.setValue(valuesQR[14].replace(',', '') > 0 ? Number(valuesQR[14].replace(',', '')) / 1000 : 0);
      this.transportForm.get('plate')?.setValue(valuesQR[8]);
      this.transportForm.get('no_ticket')?.setValue(valuesQR[0]);
    } else if (valuesQR[12] && !isNaN(parseInt(valuesQR[12].charAt(0), 10))) {
      // Boleta del sistema de inventarios viejo
      this.transportForm.get('gross_weight')?.setValue(valuesQR[12].replace(',', '') > 0 ? Number(valuesQR[12].replace(',', '')) / 1000 : 0);
      this.transportForm.get('tare_weight')?.setValue(valuesQR[13].replace(',', '') > 0 ? Number(valuesQR[13].replace(',', '')) / 1000 : 0);
      this.net_weight = valuesQR[14].replace(',', '') > 0 ? Number(valuesQR[14].replace(',', '')) / 1000 : 0;
      this.transportForm.get('origin_weight')?.setValue(valuesQR[15].replace(',', '') > 0 ? Number(valuesQR[15].replace(',', '')) / 1000 : 0);
      this.transportForm.get('plate')?.setValue(valuesQR[7]);
      this.transportForm.get('no_ticket')?.setValue(valuesQR[0]);
    } else {
      this.isValidQR = false;
    }
  }

  /**
   * Calcula y actualiza los totales de peso neto y piezas a partir de la lista de transportes.
   * @param transportList - Lista de registros de transporte sobre la que se calculan los totales.
   */
  updateTotals(transportList: Transport[]) {
    this.table_config.totals!.totalNetWeight = transportList.reduce( (previous, current) => previous + Number(current.net_weight), 0);
    this.table_config.totals!.piezas = transportList.reduce( (previous, current) => previous + Number(current.quantity_pieces), 0);
  }
}
